// extracted by css-extract-rspack-plugin
export default {"HideWhenNarrow":"OverviewSidebar-module__HideWhenNarrow__dOqz1"};